import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Typography, InputNumber } from "antd";
import UploadImage from "./UploadImage";
import { axiosInstance } from "../../../../controller/axiosInterceptor";
import "../../../../styles/form.scss";
import SpinWrapper from "../../../../common/Loader/SpinWrapper";

const SelectServices = (props) => {
  const serviceObj = {
    title: "",
    price: "",
    imgUrl: "",
    description: "",
    preferredSlotDuration: "",
    maximumNumberOfBookings: 0,
  };

  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [loader, setLoader] = useState(false);

  const {
    categoryValue,
    setCategoryValue,
    addedServices,
    setAddedServices,
    disabled,
    setDisabled,
    onlyTextHandler,
    onlyNumbersHandler,
  } = props;

  useEffect(() => {
    if (addedServices?.length === 0) {
      setDisabled(true);
    } else {
      const isFilled = addedServices?.every(
        (i) => i.title && i.subCatId && i.price && i.description && i.imgUrl !== "" && i.preferredSlotDuration
      );
      setDisabled(!isFilled);
    }

    getServices();
  }, []);

  const getServices = () => {
    axiosInstance
      .post("/admin/category/list", { page: 1, pageLimit: 10 })
      .then((resp) => {
        const modifiedArr = resp.data.output.list.map((i) => ({
          value: i._id,
          label: i.name,
        }));
        setCategoryList(modifiedArr);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (categoryValue) {
      getSubCategories();
    }
  }, [categoryValue]);

  const getSubCategories = () => {
    axiosInstance
      .post("/admin/subcategory/list", {
        categoryId: categoryValue,
        page: 1,
        pageLimit: 10,
      })
      .then((resp) => {
        const modifiedArr = resp.data.output.list.map((i) => ({
          value: i._id,
          label: i.name,
        }));
        setSubCategoryList(modifiedArr);
      })
      .catch((err) => console.log(err));
  };

  const handleAddMore = () => {
    setDisabled(true);
    const clonedArr = [...addedServices];
    clonedArr.push(serviceObj);
    setAddedServices(clonedArr);
  };

  const handleFormChange = () => {
    const hasErrors =
      !props.form.isFieldsTouched(true) ||
      props.form.getFieldsError().filter(({ errors }) => errors.length).length > 0;
    setDisabled(hasErrors);
  };

  const handleUpdateServicesArr = (key, value, idx) => {
    setDisabled(true);
    const clonedArr = [...addedServices];
    clonedArr[idx][key] = value;
    setAddedServices(clonedArr);

    if (
      clonedArr[idx].title &&
      clonedArr[idx].subCatId &&
      clonedArr[idx].price &&
      clonedArr[idx].description && clonedArr[idx].preferredSlotDuration
    ) {
      setDisabled(false);
    } else {
      setDisabled(true)
    }
  };

  const handleDeleteService = (ind) => {
    if (addedServices?.length > 1) {
      let newList = addedServices.filter((_, index) => index !== ind);
      setAddedServices(newList);

      const last = newList[newList.length - 1];
      if (last?.title && last?.subCatId && last?.price && last?.description) {
        setDisabled(false);
      }
    }
  };

  return (
    <SpinWrapper loader={loader}>
      <div className="h-100">
        <div className="row">
          <div className="col-12 text-center steps-form-heading">
            <h5>Select Services</h5>
          </div>
        </div>

        <div className="row common-form-div form-create-profile">
          <Form
            initialValues={{ remember: true }}
            autoComplete="off"
            form={props.form1Ref}
            onFieldsChange={handleFormChange}
          >
            <div className="col-12">
              <Form.Item>
                <Select
                  placeholder="Select Category"
                  options={categoryList}
                  value={categoryValue}
                  onChange={(value) => {
                    setCategoryValue(value);
                    if (addedServices.length) {
                      const clonedArr = addedServices.map((i) => ({
                        ...i,
                        subCatId: "",
                      }));
                      setAddedServices(clonedArr);
                    }
                  }}
                />
              </Form.Item>
            </div>
          </Form>
        </div>

        <div className="scroll-services">
          {categoryValue &&
            addedServices.map((i, idx) => (
              <div className="row m-0" key={idx}>
                <div className="col-12 common-form-div form-create-profile p-0">
                  <Form onFieldsChange={handleFormChange} autoComplete="off">
                    <div className="row m-0">
                      <div className="col-12 p-0">
                        <div className="row">
                          <div className="col-12 col-sm-12 text-center col-md-3">
                            <UploadImage
                              handleUpdateServicesArr={handleUpdateServicesArr}
                              idx={idx}
                              IS_SERVICES
                              currentImage={i?.imgUrl}
                              setLoader={setLoader}
                            />
                          </div>
                          <div className="col-12 col-sm-12 col-md-9">
                            <div className="row">
                              <div className="col-7">
                                <Form.Item>
                                  <Input
                                    placeholder="Service title"
                                    onChange={(e) => handleUpdateServicesArr("title", e.target.value, idx)}
                                    onKeyPress={onlyTextHandler}
                                    maxLength={36}
                                    value={i.title}
                                  />
                                </Form.Item>
                              </div>
                              <div className="col-5">
                                <Form.Item>
                                  <Select
                                    placeholder="Sub category"
                                    onChange={(value) => handleUpdateServicesArr("subCatId", value, idx)}
                                    value={i.subCatId || null}
                                    options={subCategoryList}
                                  />
                                </Form.Item>
                              </div>
                              <div className={idx > 0 ? "col-10" : "col-12"}>
                                <Form.Item>
                                  <Input
                                    placeholder="Service fee"
                                    prefix="$"
                                    className="service-prefix"
                                    type="text"
                                    maxLength={4}
                                    onKeyPress={onlyNumbersHandler}
                                    onWheel={props.scrollEffectHandler}
                                    onChange={(e) => handleUpdateServicesArr("price", e.target.value, idx)}
                                    value={i?.price}
                                  />
                                </Form.Item>
                              </div>
                              {idx > 0 && (
                                <div className="col-2 delete-service">
                                  <span onClick={() => handleDeleteService(idx)}>
                                    <img
                                      src="/assets/icons/deleteServiceIcon.svg"
                                      alt="delete-service"
                                      className="dlt-service-icon"
                                    />
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 p-0">
                        <Form.Item>
                          <Input.TextArea
                            className="textarea-message textarea-description"
                            style={{ height: "92px" }}
                            placeholder="Service description"
                            onChange={(e) => handleUpdateServicesArr("description", e.target.value, idx)}
                            maxLength={255}
                            value={i?.description}
                          />
                        </Form.Item>
                      </div>

                      {/* Slot Duration */}
                      <div className="col-12">
                        <Typography.Text strong>Preferred Slot durations</Typography.Text>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '10px' }}>
                          {[15, 30, 45, 60, 75, 90, 105, 120].map((duration) => (
                            <Button
                              key={duration}
                              shape="round"
                              type={i.preferredSlotDuration === duration ? 'primary' : 'default'}
                              onClick={() => handleUpdateServicesArr('preferredSlotDuration', duration, idx)}
                              style={{
                                background: i.preferredSlotDuration === duration ? 'linear-gradient(135deg, #2dd4bf, #3b82f6)' : '#f0f2f5',
                                color: i.preferredSlotDuration === duration ? '#fff' : '#000',
                                border: 'none',
                                fontWeight: 600,
                                height: "60px",
                                width: "109px"
                              }}
                            >
                              {duration} mins
                            </Button>
                          ))}
                        </div>
                      </div>

                      {/* Max Bookings */}
  <div className="col-12 mt-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <Typography.Text>
    What are the maximum number of bookings you would accept for this service?
  </Typography.Text>

  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    {/* Minus Button */}
    <Button
      shape="circle"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: '1px solid #000',
        backgroundColor: '#fff',
        color: '#000',
        width: '36px',
        height: '36px',
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0
      }}
      onClick={() => {
        const current = i.maximumNumberOfBookings || 0;
        if (current > 0) handleUpdateServicesArr('maximumNumberOfBookings', current - 1, idx);
      }}
    >
     <img
            src="/assets/icons/minus-filled.svg"
            alt="Minus"
          />
    </Button>

    {/* Display Number */}
    <Typography.Text strong style={{ fontSize: '14px', minWidth: '10px', textAlign: 'center',     whiteSpace: 'nowrap' }}>
      {i.maximumNumberOfBookings || 0}
    </Typography.Text>

    {/* Plus Button */}
    <Button
    shape="circle"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: '#0E1E40',
        color: '#fff',
        border: 'none',
        width: '36px',
        height: '36px',
        fontSize: '20px',
        fontWeight: 'bold',
        margin: 0
      }}
      onClick={() => {
        const current = i.maximumNumberOfBookings || 0;
        handleUpdateServicesArr('maximumNumberOfBookings', current + 1, idx);
      }}
    >
       <img
            src="/assets/icons/plus-filled.svg"
            alt="Plus"
          />
    </Button>
  </div>
</div>


                    </div>
                  </Form>
                </div>
              </div>
            ))}
              <div className="col-12 mt-3">
                        <div
                          style={{
                            border: '2px solid #f9fafb',
                            borderRadius: '18px',
                            padding: '12px 12px 12px 12px',
                            marginTop: '16px',
                            color: '#6b7280',
                          }}
                        >
                          <img
                            src="/assets/icons/info-black.png"
                            alt="info"
                            style={{ width: '20px', marginRight: '10px', marginBottom: "10px"}}
                          />
                          <br />
                          <Typography.Text style={{color: "#777D88"}}>
                            If you prefer not to limit the number of bookings, set this value to 0. You'll receive every booking request we get.
                          </Typography.Text>
                        </div>
                      </div>
        </div>

        {categoryValue && (
          <div className="row m-0">
            <div className="col-12" style={{ marginTop: "-4px" }}>
              <Button
                className={disabled ? "common-btn ms-auto" : "common-btn-dis  ms-auto  "}
                style={{ maxWidth: "130px" }}
                onClick={handleAddMore}
                disabled={disabled}
              >
                Add More
              </Button>
            </div>
          </div>
        )}
      </div>
    </SpinWrapper>
  );
};

export default SelectServices;
